import React, {useRef} from 'react';
import Utils from "../../../../../../../../../../utils/Utils";
import {MenuProductViewType} from "../../../../../../../../../../services/Api/types";
import ScrollableTabs from "../../../../../../../../../../components/Common/ScrollableTabs";
import {MultistoreMenuCategory, MultistoreMenuItem} from "../../../../../../../../utils/types";
import MultistoreMenuCategoryProduct from "../MultistoreMenuCategoryProduct";

interface Props {
    category: MultistoreMenuCategory;
    menuId: number;
    productsViewType: MenuProductViewType;
    itemOnClick: (item: MultistoreMenuItem) => void;
}

const MultistoreMenuCategorySection = ({category, menuId, productsViewType, itemOnClick}: Props) => {
    const scrollableWrapperRef = useRef<HTMLDivElement | null>(null);

    const renderItems = () => {
        return category.items.map((item) => {
                return <MultistoreMenuCategoryProduct
                    viewType={productsViewType}
                    product={item}
                    key={`item-${category.id}-${item.id}`}
                    onClick={() => itemOnClick(item)}
                />
            }
        )
    };

    return (
        <section className="menu-category scrollspy-section"
                 id={`category-${menuId}-${category.id}`}>
            <div className="menu-category-header">
                <div className="d-flex align-items-start justify-content-between gap-2">
                    <h1 className="h4">{category.name}</h1>
                </div>
                {category.description && (
                    <p dangerouslySetInnerHTML={{__html: Utils.nl2brString(category.description)}}></p>
                )}
            </div>
            {
                productsViewType === MenuProductViewType.VERTICAL_SMALL_IMAGE && (
                    <div
                        className="menu-items menu-items-grid">
                        {renderItems()}
                    </div>
                )
            }
            {
                productsViewType === MenuProductViewType.HORIZONTAL && (
                    <div ref={scrollableWrapperRef}>
                        <ScrollableTabs hideScrollbars={false} scrollStep={250}
                                        className="menu-items menu-items-horizontal-list">
                            {renderItems()}
                        </ScrollableTabs>
                    </div>
                )
            }
            {
                productsViewType === MenuProductViewType.VERTICAL_BIG_IMAGE && (
                    <div
                        className="menu-items menu-items-grid-with-big-images">
                        {renderItems()}
                    </div>
                )
            }
        </section>
    )
}

export default MultistoreMenuCategorySection;